import React from 'react';
import {HelmetProvider} from 'react-helmet-async';
import {BoardApp} from './components/board-app';
import {Website} from './components/website';

export function App(): React.ReactElement {
  return (
    <HelmetProvider>
      <BoardApp />
      <Website />
    </HelmetProvider>
  );
}
